var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentStaggeredLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 13.25H1.7998V15.25H9.7998V13.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 21.25H3.7998V23.25H11.7998V21.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 17.25H5.7998V19.25H13.7998V17.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5498 3H18.2998V2.25C18.2998 1.42 17.6298 0.75 16.7998 0.75H10.7998C9.9698 0.75 9.2998 1.42 9.2998 2.25V3H7.0498C6.2198 3 5.5498 3.67 5.5498 4.5V11.75H7.0498V4.5H9.2998V6.75H18.2998V4.5H20.5498V20.25H13.2998V21.75H20.5498C21.3798 21.75 22.0498 21.08 22.0498 20.25V4.5C22.0498 3.67 21.3798 3 20.5498 3ZM16.7998 5.25H10.7998V2.25H16.7998V5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentStaggeredLines);
export default __webpack_public_path__ + "static/media/ic-document-staggered-lines.55495fcdcd097cbf62c0e0640a202888.svg";
export { ForwardRef as ReactComponent };